import { useCallback, useEffect } from 'react';
import { useProjectsDispatch, useProjectsSelector } from '@src/contexts';
import { useLocalStorage } from './useLocalStorage';

const LAST_SELECTED_PROJECT_KEY = 'lastSelectedProjectId';

export function useLastSelectedProject() {
  const { getValue, setValue } = useLocalStorage<string>(LAST_SELECTED_PROJECT_KEY);
  const selectedProjectId = useProjectsSelector(store => store.lastSelectedProjectId);
  const dispatch = useProjectsDispatch();

  // Initialize from localStorage on mount
  useEffect(() => {
    const storedProjectId = getValue();
    if (storedProjectId && !selectedProjectId) {
      dispatch({ lastSelectedProjectId: storedProjectId });
    }
  }, [dispatch, selectedProjectId, getValue]);

  // Update  context and localStorage
  const setLastSelectedProjectId = useCallback(
    (projectId: string) => {
      setValue(projectId);
      dispatch({ lastSelectedProjectId: projectId });
    },
    [dispatch, setValue]
  );

  return {
    lastSelectedProjectId: selectedProjectId,
    setLastSelectedProjectId,
  };
}
